import request from './request'

// 上传小说文件
export function uploadNovel(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/officialWebsite/submission/uploadNovel', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 创建小说信息
export function createSubmission(data) {
  // data: { bookTitle, editor, contractType, email, url, fileName }
  return request.post('/officialWebsite/submission/create', data)
}
